export default __webpack_public_path__ + "public/media/server-maintenance.6c156b77.png";